import { render, staticRenderFns } from "./TablaResumenCombosDevueltos.vue?vue&type=template&id=98ec4ef6"
import script from "./TablaResumenCombosDevueltos.vue?vue&type=script&lang=js"
export * from "./TablaResumenCombosDevueltos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports